var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongEnter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3a.5.5 0 000 1V3zm-6 7a.5.5 0 000 1v-1zm6-6H13V3H9.5v1zM13 4v6h1V4h-1zm0 6H3.5v1H13v-1zm0 0v1a1 1 0 001-1h-1zm0-6h1a1 1 0 00-1-1v1z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.5l-3 3 3 3",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNSAzQzkuMjIzODYgMyA5IDMuMjIzODYgOSAzLjVDOSAzLjc3NjE0IDkuMjIzODYgNCA5LjUgNFYzWk0zLjUgMTBDMy4yMjM4NiAxMCAzIDEwLjIyMzkgMyAxMC41QzMgMTAuNzc2MSAzLjIyMzg2IDExIDMuNSAxMVYxMFpNOS41IDRIMTNWM0g5LjVWNFpNMTMgNFYxMEgxNFY0SDEzWk0xMyAxMEgzLjVWMTFIMTNWMTBaTTEzIDEwVjExQzEzLjU1MjMgMTEgMTQgMTAuNTUyMyAxNCAxMEgxM1pNMTMgNEgxNEMxNCAzLjQ0NzcyIDEzLjU1MjMgMyAxMyAzVjRaIiBmaWxsPSIjM0Y0NjVDIi8+CjxwYXRoIGQ9Ik01LjUgNy41TDIuNSAxMC41TDUuNSAxMy41IiBzdHJva2U9IiMzRjQ2NUMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgTongyongEnter as ReactComponent };